import { EcpServices } from '../../ecp-locator';
import { aecColor, cvColor, mainColor } from '../../../../../themes/default';

export const getDateTitle = (service?: EcpServices): { title: string, color: string } => {
  switch (service) {
    case EcpServices.aec:
      return { title: 'appointmentRegistration.dateStep.title.aec', color: aecColor };
    case EcpServices.cv:
      return { title: 'appointmentRegistration.dateStep.title.cv', color: cvColor };
    default:
      return { title: 'appointmentRegistration.dateStep.title', color: mainColor };
  }
};
